import { Box } from "@mui/material";
import { Page } from "react-pdf";
import { PagePlaceholder } from "@entrilia/shared/components/previewFile/pdfViewer/PdfPagesContainer";
import CitationHighlightOverlay from "./CitationHighlightOverlay";
import type { CitationHighlight } from "./citationHighlightsHelper";
import { rotateHighlight } from "./citationHighlightsHelper";

interface Props {
  pageNumber: number;
  pageHeight: number | undefined;
  pageWidth: number | undefined;
  renderPage: boolean;
  renderLayers: boolean;
  highlights: CitationHighlight[];
  selectedCitationId: string | undefined;
  rotationDegrees: number;
}

const PdfCitationPage = ({
  pageNumber,
  pageHeight,
  pageWidth,
  renderPage,
  renderLayers,
  highlights,
  selectedCitationId,
  rotationDegrees,
}: Props) => (
  <Box sx={{ position: "relative" }}>
    <Page
      pageNumber={pageNumber}
      height={pageHeight}
      width={pageWidth}
      customRenderer={renderPage ? undefined : PagePlaceholder}
      renderMode={renderPage ? "canvas" : "custom"}
      renderAnnotationLayer={renderLayers}
      renderTextLayer={renderLayers}
    />
    {renderPage &&
      highlights.map((highlight, index) => (
        <CitationHighlightOverlay
          // eslint-disable-next-line @eslint-react/no-array-index-key
          key={`${highlight.citationId}-${index}`}
          highlight={rotateHighlight(highlight, rotationDegrees)}
          isSelected={highlight.citationId === selectedCitationId}
        />
      ))}
  </Box>
);

export default PdfCitationPage;
